module.exports = __webpack_public_path__ + "static/media/ResponPic7.7f61834b.jpg";